import React from 'react';

const IconChevron = () => {
    return (
        <svg
            width="6"
            height="9"
            viewBox="0 0 6 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.22763 4.5L-1.18195e-07 7.64801L1.38619 9L6 4.5L1.38618 8.3249e-07L-6.6861e-07 1.35199L3.22763 4.5Z"
                fill="#F9FAFA"
            />
        </svg>
    );
};

export default IconChevron;
